import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
// action
import { userForgetPasswordResendCode, userResetPassword } from "../../store/actions";

// import images
import profile from '../../assets/images/Glottis - Logo shap.png';
import logo from "assets/images/welcome-logo.png";
import { useParams } from 'react-router-dom';
import PasswordStrengthMeter from "constants/PasswordStrengthMeter";
import AuthLoader from "components/Common/AuthLoader";

const ResetPassword = props => {
    let { email } = useParams();
    const [passwordNew, setPasswordNew] = useState(false);
    const [passwordConf, setPasswordConf] = useState(false);
    const [minutes, setMinutes] = useState(2);
    const [seconds, setSeconds] = useState(0);
    const [passwordValidate, setPasswordValidate] = useState('')

    //meta title
    document.title = "Reset Password | Glottis Logistics";

    const dispatch = useDispatch();

    const resetForm = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: email,
            pwd: '',
            confPwd: '',
            verificationToken: ''
        },
        validationSchema: Yup.object({
            pwd: Yup.string().required("Enter new password").test("pwd_length", "Password should reach atleast medium strength", val => passwordValidate >= 2),
            confPwd: Yup.string().required('Enter confirm password').when("pwd", {
                is: val => (val && val.length > 0 ? true : false),
                then: Yup.string().oneOf(
                    [Yup.ref("pwd")],
                    "New and confirm password must be matched"
                )
            }),
            verificationToken: Yup.string().required("Enter verification code"),
        }),
        onSubmit: (values) => {
            dispatch(userResetPassword(values, props.history));
        }
    });

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);
    const resendOTP = () => {
        setMinutes(1);
        setSeconds(30);
        dispatch(userForgetPasswordResendCode({ email }))
    };
    const [password, setPassword] = useState('')
    useEffect(() => {
        setPassword(resetForm.values.pwd)
    }, [resetForm.values.pwd])

    const { Loader } = useSelector(state => ({
        Loader: state.ResetPassword.resetLoader
    }));
  
    return (
        <React.Fragment>
            {/* <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
        <i className="bx bx-home h2" />
        </Link>
      </div> */}
            <div className="account-pages ">
                <div className="reset-password">
                    <Container>
                        <div className="text-center auth-logo">
                            <img src={logo} alt="Logo" />
                        </div>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>                          
                            <Card className="overflow-hidden auth-card">
                                <div className="bg-primary bg-soft background-auth-page">
                                    <Row className="align-items-center auth-head">
                                        <Col xs={7} className='auth-heading'>
                                            <div className="auth-heading-text">
                                                <h2 className="f-size-24">Reset Password</h2>
                                                <p className="f-size-12">Enter the 6 digits code that you received on your email and set the new password for your account.</p>
                                            </div>
                                        </Col>
                                        <Col xs={5} className="align-self-end logo-img">
                                            <img src={profile} alt="" className="img-fluid" />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody>
                                    {/* <div className="d-inline-block">
                                        <Link to="/">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src={logo}
                                                        alt="logo"
                                                        className="rounded-circle"
                                                        height="34"
                                                    />
                                                </span>
                                            </div>
                                        </Link>
                                    </div> */}
                                    <div>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                resetForm.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <div>
                                                <Label className="form-label mt-3 f-size-14">Verification code <span>*</span></Label>
                                                <Input
                                                    name="verificationToken"
                                                    className="form-control f-size-14"
                                                    type="number"
                                                    placeholder="xxxxxx"
                                                    onChange={resetForm.handleChange}
                                                    onBlur={resetForm.handleBlur}
                                                    value={resetForm.values.verificationToken || ""}
                                                    invalid={
                                                        resetForm.touched.verificationToken && resetForm.errors.verificationToken ? true : false
                                                    }

                                                />
                                                 {resetForm.touched.verificationToken && resetForm.errors.verificationToken ? (
                                                    <FormFeedback type="invalid">{resetForm.errors.verificationToken}</FormFeedback>
                                                ) : null}
                                                <div className="countdown-text">
                                                    {seconds > 0 || minutes > 0 ? (
                                                        <p className="f-size-12 timing">Time remaining: <span className="remaining-time">{minutes < 10 ? `0${minutes}` : minutes}:
                                                            {seconds < 10 ? `0${seconds}` : seconds}</span>
                                                        </p>
                                                    ) : (
                                                        <p className="f-size-12 timing">Didn't recieve code?</p>
                                                    )}

                                                    <button className="border-0 bg-transparent p-0 resend-code"
                                                        disabled={seconds > 0 || minutes > 0}
                                                        style={{
                                                            color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#DF0C00",
                                                        }}
                                                        onClick={resendOTP}
                                                    >
                                                        Resend code
                                                    </button>
                                                </div>
                                               
                                            </div>
                                            <div>
                                                <Label className="form-label f-size-14">New password <span>*</span></Label>
                                                <div className="input-group auth-pass-inputgroup">

                                                    <Input
                                                        name="pwd"
                                                        className="form-control password-input f-size-14"
                                                        placeholder="*******"
                                                        type={passwordNew ? "text" : "password"}
                                                        onChange={resetForm.handleChange}
                                                        onBlur={resetForm.handleBlur}
                                                        value={resetForm.values.pwd || ""}
                                                        invalid={
                                                            resetForm.touched.pwd && resetForm.errors.pwd ? true : false
                                                        }
                                                    />
                                                    <button onClick={() => setPasswordNew(prevState => !prevState)} className="btn" type="button" id="password-addon">
                                                        {passwordNew ? <i className="mdi mdi-eye-outline"></i> : <i className="mdi mdi-eye-off-outline .font-size-15"></i>}
                                                    </button>
                                                    <div className="w-100">
                                                        <PasswordStrengthMeter password={password} setPasswordValidate={setPasswordValidate} />
                                                    </div>
                                                    {resetForm.touched.pwd && resetForm.errors.pwd ? (
                                                        <FormFeedback type="invalid">{resetForm.errors.pwd}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div>
                                                <Label className="form-label f-size-14">Confirm password <span>*</span></Label>
                                                <div className="input-group auth-pass-inputgroup">

                                                    <Input
                                                        name="confPwd"
                                                        className="form-control password-input f-size-14"
                                                        type={passwordConf ? "text" : "password"}
                                                        placeholder="********"
                                                        onChange={resetForm.handleChange}
                                                        onBlur={resetForm.handleBlur}
                                                        value={resetForm.values.confPwd || ""}
                                                        invalid={
                                                            resetForm.touched.confPwd && resetForm.errors.confPwd ? true : false
                                                        }
                                                    />
                                                    <button onClick={() => setPasswordConf(prevState => !prevState)} className="btn" type="button" id="password-addon">
                                                        {passwordConf ? <i className="mdi mdi-eye-outline"></i> : <i className="mdi mdi-eye-off-outline .font-size-15"></i>}
                                                    </button>
                                                    {resetForm.touched.confPwd && resetForm.errors.confPwd ? (
                                                        <FormFeedback type="invalid">{resetForm.errors.confPwd}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </div>
                                            {Loader === true ? <AuthLoader/>:
                                            <div className="d-grid">
                                                <button
                                                    className="btn btn-primary btn-block primary-button"
                                                    type="submit"
                                                    >
                                                    Reset Password
                                                </button>
                                            </div>
                                                }
                                            <p className="go-back f-size-12">
                                                Go back to{" "}
                                                <Link to="/login" className="font-weight-medium primary-color f-size-12">
                                                    Login
                                                </Link>{" "}
                                            </p>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                          
                        </Col>
                        </Row>
                        <div className="text-center copy-right">
                            <p> Glottis @ {new Date().getFullYear()} All Rights Reserved </p>
                        </div>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

ResetPassword.propTypes = {
    history: PropTypes.object,
};

export default withRouter(ResetPassword);
